export enum TabId {
    USER_ROLE_MANAGEMENT = 'user-role-management',
    AI_ASSIST_USAGE = 'ai-assist-usage',
    CONTRACTS_GENERATION = 'contracts-generation',
    EVENT_FAMILIES = 'event-families',
}

export enum TabCaption {
    USER_ROLE_MANAGEMENT = 'User Role Management',
    AI_ASSIST_USAGE = 'AI Assist Usage',
    CONTRACTS_GENERATION = 'Contracts Generation',
    EVENT_FAMILIES = 'Event Families',
}

export type TabItem = {
    caption: TabCaption,
    tabId: TabId,
};
